import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import api, { fmtErr } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(fmtErr(err));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full rounded-xl border border-white/15 bg-[#0F1418] px-4 py-3 text-sm text-white outline-none transition-colors focus:border-[#D4AF37]";

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        className="w-full max-w-sm rounded-3xl border border-white/10 bg-[#171F26] p-8"
      >
        <p className="text-xs font-medium uppercase tracking-[0.3em] text-[#D4AF37]">Jay Jagannath Travels</p>
        <h1 className="mt-3 font-serif text-2xl font-semibold">Admin login</h1>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <input data-testid="admin-login-email" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} />
          <input data-testid="admin-login-password" type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} />
          {error && (
            <p data-testid="admin-login-error" className="rounded-lg border border-red-500/30 bg-red-500/10 px-4 py-2 text-sm text-red-300">
              {error}
            </p>
          )}
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="w-full rounded-full bg-[#D4AF37] px-6 py-3 text-sm font-semibold text-[#0F1418] transition-transform hover:scale-[1.02] disabled:opacity-60"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
        <Link to="/" data-testid="admin-login-home-link" className="mt-5 block text-center text-xs text-white/40 transition-colors hover:text-[#D4AF37]">
          ← Back to website
        </Link>
      </motion.div>
    </div>
  );
}
